import { amountAsCurrency } from "currency";
import { View } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { TransactionDetails } from "../../types";
import { formatDate } from "../../utils/formatDate";
import CardText from "../CardText";
import { StatusLabels } from "../StatusLabel";

type Props = {
  summary: TransactionDetails["summary"];
};

export default function SaleSummary({ summary }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  const textVariantStyle = { color: colors.onSurfaceVariant };

  const { consumerName, saleType, amount, currency, statuses } = summary;

  const timestamp = formatDate(summary.timestamp || "");

  return (
    <View style={tailwind("mx-4")}>
      <View style={tailwind("flex-row justify-between")}>
        <View>
          <Text variant="bodyLarge">{consumerName}</Text>
          {saleType && (
            <CardText.Subtitle text={saleType} style={tailwind("my-1")} />
          )}
        </View>
        <Text variant="headlineSmall" style={textVariantStyle}>
          {amountAsCurrency({ amount, currency })}
        </Text>
      </View>

      {timestamp && <CardText.Body text={timestamp} style={tailwind("mb-1")} />}

      <StatusLabels statuses={statuses} />
    </View>
  );
}
